module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0585":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".discord-reaction{color:#72767d;background-color:hsla(0,0%,100%,.05);padding:0 .4em;border-radius:4px;margin-right:2px;margin-bottom:2px}.discord-reaction:hover{color:#dcddde}.discord-reaction.discord-reaction-active{color:#7289da;background-color:rgba(114,137,218,.3)}", ""]);

// exports


/***/ }),

/***/ "0ac0":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".discord-message .discord-author-info{color:#fff;display:inline-flex;align-items:center;font-size:15px}.discord-message .discord-author-info .discord-author-username{font-size:1.1em;font-weight:500;letter-spacing:.5px}.discord-light-theme .discord-message .discord-author-info .discord-author-username{color:#23262a}.discord-message .discord-author-info .discord-bot-tag{background-color:#7289da;font-size:.65em;margin-left:5px;padding:3px;border-radius:3px;line-height:100%;text-transform:uppercase}.discord-light-theme .discord-message .discord-author-info .discord-bot-tag{color:#fff}.discord-compact-mode .discord-message .discord-author-info{display:inline-flex;flex-direction:row-reverse}.discord-compact-mode .discord-message .discord-author-info .discord-author-username{margin-left:4px;margin-right:4px}.discord-compact-mode .discord-message .discord-author-info .discord-bot-tag{margin-left:0;margin-right:5px;padding-left:3px;padding-right:3px;font-size:.6em}", ""]);

// exports


/***/ }),

/***/ "1583":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".discord-messages{color:#fff;background-color:#36393e;font-size:16px;font-family:sans-serif;line-height:170%;border:1px solid hsla(0,0%,100%,.05)}.discord-messages.discord-light-theme{color:#747f8d;background-color:#f7f7f7;border-color:#dedede}", ""]);

// exports


/***/ }),

/***/ "187f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1583");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("22aa0ace", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1d0c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("56b5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0a9004f3", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2350":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "2cc1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Mention_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("56ba");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Mention_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Mention_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Mention_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2df6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".discord-embed{color:#dcddde;display:flex;margin-top:8px;margin-bottom:8px;font-size:13px;line-height:150%}.discord-light-theme .discord-embed{color:#2e3338}.discord-embed .discord-left-border{background-color:#202225;flex-shrink:0;width:4px;border-radius:4px 0 0 4px}.discord-light-theme .discord-embed .discord-left-border{background-color:#e3e5e8}.discord-embed .discord-embed-container{background-color:#2f3136;display:flex;flex-direction:column;max-width:520px;padding:8px 16px 16px;border:1px solid rgba(46,48,54,.6);border-radius:0 4px 4px 0}.discord-light-theme .discord-embed .discord-embed-container{background-color:hsla(0,0%,97.6%,.3);border-color:hsla(0,0%,80.4%,.3)}.discord-embed .discord-embed-content{display:flex}.discord-embed .discord-embed-thumbnail{max-width:80px;max-height:80px;margin-left:16px;margin-top:8px;border-radius:4px;-o-object-fit:contain;object-fit:contain;-o-object-position:top center;object-position:top center}.discord-embed .discord-embed-author{color:#fff;display:flex;align-items:center;font-weight:500;margin-top:8px}.discord-light-theme .discord-embed .discord-embed-author{color:#4f545c}.discord-embed .discord-embed-author a{color:#fff}.discord-light-theme .discord-embed .discord-embed-author a{color:#4f545c}.discord-embed .discord-embed-author .discord-author-image{width:24px;height:24px;margin-right:8px;border-radius:50%}.discord-embed .discord-embed-title{color:#fff;font-size:16px;font-weight:600;margin-top:8px}.discord-embed .discord-embed-title a{color:#00b0f4;font-weight:600}.discord-embed .discord-embed-description{margin-top:8px}.discord-embed .discord-embed-image{max-width:100%;margin-top:16px;border-radius:4px}.discord-embed .discord-embed-footer{color:#72767d;display:flex;align-items:center;font-size:.85em;margin-top:8px}.discord-embed .discord-embed-footer .discord-footer-image{flex-shrink:0;width:20px;height:20px;margin-right:8px;border-radius:50%}.discord-embed .discord-embed-footer .discord-footer-separator{color:#3b3c42;font-weight:700;margin:0 4px}.discord-light-theme .discord-embed .discord-embed-footer .discord-footer-separator{color:#e4e4e4}", ""]);

// exports


/***/ }),

/***/ "3f9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordReaction_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("73f2");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordReaction_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordReaction_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordReaction_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "4116":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordMessages_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("187f");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordMessages_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordMessages_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordMessages_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "4946":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".discord-message .discord-mention{color:#7289da;background-color:rgba(114,137,218,.1);font-weight:500;padding:0 1px}.discord-message .discord-mention:hover{color:#fff;background-color:rgba(114,137,218,.7)}.discord-message.discord-highlight-mention{background-color:rgba(250,166,26,.05);position:relative}.discord-message.discord-highlight-mention:before{content:\"\";background-color:#faa61a;display:block;position:absolute;top:0;left:0;bottom:0;width:2px}.discord-message.discord-highlight-mention:hover{background-color:rgba(250,166,26,.1)}.discord-message.discord-highlight-mention .discord-mention{background-color:unset!important}.discord-message.discord-highlight-mention .discord-mention:hover{color:#7289da;text-decoration:underline}", ""]);

// exports


/***/ }),

/***/ "4963":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordReactions_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("77be");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordReactions_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordReactions_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordReactions_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return addStylesClient; });
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4c75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordMessage_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e5a6");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordMessage_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordMessage_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordMessage_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "56b5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700);", ""]);

// module
exports.push([module.i, ".discord-messages{font-family:Roboto,sans-serif}", ""]);

// exports


/***/ }),

/***/ "56ba":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4946");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5a98be86", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5e21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AuthorInfo_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c7a3");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AuthorInfo_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AuthorInfo_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AuthorInfo_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7240":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ca1d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("b1e9c43e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "73f2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0585");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("68464713", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "77be":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("a371");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("f68ea3fe", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7baf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_EmbedFields_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a49c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_EmbedFields_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_EmbedFields_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_EmbedFields_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9316":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".discord-message{color:#dcddde;display:flex;font-size:.9em;margin:1em 0;padding:.25em 1em 0}.discord-message:hover{background-color:#32353b}.discord-light-theme .discord-message{color:#2e3338}.discord-light-theme .discord-message:hover{background-color:#fafafa}.discord-message a{color:#0096cf;font-weight:400;text-decoration:none}.discord-message a:hover{text-decoration:underline}.discord-light-theme .discord-message a{color:#00b0f4}.discord-message .discord-author-avatar{margin-top:1px;margin-right:16px;min-width:40px}.discord-message .discord-author-avatar img{width:40px;height:40px;border-radius:50%}.discord-message .discord-message-timestamp{color:#72767d;font-size:12px;margin-left:3px}.discord-message .discord-message-edited{color:#72767d;font-size:10px}.discord-message .discord-message-content{width:100%;line-height:160%;font-weight:400;overflow-wrap:anywhere}.discord-message .discord-message-body{position:relative}.discord-compact-mode.discord-light-theme .discord-message:hover .discord-message-timestamp,.discord-compact-mode .discord-message:hover .discord-message-timestamp,.discord-light-theme .discord-message .discord-message-timestamp{color:#99aab5}.discord-compact-mode.discord-light-theme .discord-message .discord-message-timestamp{color:#d1d9de}.discord-compact-mode .discord-message{margin:.15em 0;padding-left:.25em;padding-right:.25em}.discord-compact-mode .discord-author-avatar{display:none}.discord-compact-mode .discord-message-body{margin-left:.25em}", ""]);

// exports


/***/ }),

/***/ "a371":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".discord-reactions{display:flex;flex-wrap:wrap}", ""]);

// exports


/***/ }),

/***/ "a49c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("df45");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6754de66", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ab14":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var removeHash = function removeHash(hex) {
  return hex.charAt(0) === '#' ? hex.slice(1) : hex;
};

var parseHex = function parseHex(nakedHex) {
  var isShort = nakedHex.length === 3 || nakedHex.length === 4;

  var twoDigitHexR = isShort ? '' + nakedHex.slice(0, 1) + nakedHex.slice(0, 1) : nakedHex.slice(0, 2);
  var twoDigitHexG = isShort ? '' + nakedHex.slice(1, 2) + nakedHex.slice(1, 2) : nakedHex.slice(2, 4);
  var twoDigitHexB = isShort ? '' + nakedHex.slice(2, 3) + nakedHex.slice(2, 3) : nakedHex.slice(4, 6);
  var twoDigitHexA = (isShort ? '' + nakedHex.slice(3, 4) + nakedHex.slice(3, 4) : nakedHex.slice(6, 8)) || 'ff';

  // const numericA = +((parseInt(a, 16) / 255).toFixed(2));

  return {
    r: twoDigitHexR,
    g: twoDigitHexG,
    b: twoDigitHexB,
    a: twoDigitHexA
  };
};

var hexToDecimal = function hexToDecimal(hex) {
  return parseInt(hex, 16);
};

var hexesToDecimals = function hexesToDecimals(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b,
      a = _ref.a;
  return {
    r: hexToDecimal(r),
    g: hexToDecimal(g),
    b: hexToDecimal(b),
    a: +(hexToDecimal(a) / 255).toFixed(2)
  };
};

var isNumeric = function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}; // eslint-disable-line no-restricted-globals, max-len

var formatRgb = function formatRgb(decimalObject, parameterA) {
  var r = decimalObject.r,
      g = decimalObject.g,
      b = decimalObject.b,
      parsedA = decimalObject.a;

  var a = isNumeric(parameterA) ? parameterA : parsedA;

  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
};

/**
 * Turns an old-fashioned css hex color value into a rgb color value.
 *
 * If you specify an alpha value, you'll get a rgba() value instead.
 *
 * @param The hex value to convert. ('123456'. '#123456', ''123', '#123')
 * @param An alpha value to apply. (optional) ('0.5', '0.25')
 * @return An rgb or rgba value. ('rgb(11, 22, 33)'. 'rgba(11, 22, 33, 0.5)')
 */
var hexToRgba = function hexToRgba(hex, a) {
  var hashlessHex = removeHash(hex);
  var hexObject = parseHex(hashlessHex);
  var decimalObject = hexesToDecimals(hexObject);

  return formatRgb(decimalObject, a);
};

module.exports = hexToRgba;

/***/ }),

/***/ "be01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordEmbed_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fdf5");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordEmbed_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordEmbed_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DiscordEmbed_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "c7a3":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0ac0");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("ae58be3e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ca1d":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".discord-embed .discord-embed-field{min-width:100%;margin-top:5px}.discord-embed .discord-embed-field.discord-inline-field{flex-grow:1;flex-basis:auto;min-width:100px}.discord-embed .discord-embed-field .discord-field-title{color:#72767d;font-weight:500;margin-bottom:2px}.discord-light-theme .discord-embed .discord-embed-field .discord-field-title{color:#747f8d}", ""]);

// exports


/***/ }),

/***/ "d8f7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_EmbedField_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7240");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_EmbedField_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_EmbedField_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_EmbedField_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "df45":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".discord-embed .discord-embed-fields{display:flex;flex-wrap:wrap;margin-top:8px}", ""]);

// exports


/***/ }),

/***/ "e5a6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9316");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("106bd0a1", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"120fadbc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DiscordMessages.vue?vue&type=template&id=7af25cca&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discord-messages",class:_vm.layout},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/DiscordMessages.vue?vue&type=template&id=7af25cca&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DiscordMessages.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var DiscordMessagesvue_type_script_lang_js_ = ({
  name: 'DiscordMessages',
  props: {
    lightTheme: Boolean,
    compactMode: Boolean
  },
  computed: {
    layout() {
      const options = this.$root.$discordMessage;
      const lightTheme = this.lightTheme || options.defaultTheme === 'light';
      const compactMode = this.compactMode || options.defaultMode === 'compact';
      return {
        'discord-light-theme': lightTheme,
        'discord-compact-mode': compactMode
      };
    }

  }
});
// CONCATENATED MODULE: ./src/components/DiscordMessages.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_DiscordMessagesvue_type_script_lang_js_ = (DiscordMessagesvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/DiscordMessages.vue?vue&type=style&index=0&lang=css&
var DiscordMessagesvue_type_style_index_0_lang_css_ = __webpack_require__("4116");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/DiscordMessages.vue






/* normalize component */

var component = normalizeComponent(
  components_DiscordMessagesvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DiscordMessages = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"120fadbc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DiscordMessage.vue?vue&type=template&id=7d2ac308&
var DiscordMessagevue_type_template_id_7d2ac308_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discord-message",class:{ 'discord-highlight-mention': _vm.highlightMention }},[_c('div',{staticClass:"discord-author-avatar"},[_c('img',{attrs:{"src":_vm.user.avatar,"alt":_vm.user.author}})]),_c('div',{staticClass:"discord-message-content"},[(!_vm.compactMode)?_c('div',[_c('author-info',{attrs:{"bot":_vm.user.bot,"role-color":_vm.user.roleColor}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.user.author)+"\n\t\t\t")]),_c('span',{staticClass:"discord-message-timestamp"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm._f("padZeroes")(_vm._f("formatDate")(_vm.timestamp)))+"\n\t\t\t")])],1):_vm._e(),_c('div',{staticClass:"discord-message-body"},[(_vm.compactMode)?[_c('span',{staticClass:"discord-message-timestamp"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm._f("padZeroes")(_vm._f("formatDate")(_vm.timestamp)))+"\n\t\t\t\t")]),_c('author-info',{attrs:{"bot":_vm.user.bot,"role-color":_vm.user.roleColor}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.user.author)+"\n\t\t\t\t")])]:_vm._e(),_vm._t("default"),(_vm.edited)?_c('span',{staticClass:"discord-message-edited"},[_vm._v("(edited)")]):_vm._e()],2),_vm._t("embeds")],2)])}
var DiscordMessagevue_type_template_id_7d2ac308_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/DiscordMessage.vue?vue&type=template&id=7d2ac308&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"120fadbc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AuthorInfo.vue?vue&type=template&id=7b46319c&
var AuthorInfovue_type_template_id_7b46319c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"discord-author-info"},[_c('span',{staticClass:"discord-author-username",style:({ color: _vm.roleColor })},[_vm._t("default")],2),(_vm.bot)?_c('span',{staticClass:"discord-bot-tag"},[_vm._v("\n\t\tBot\n\t")]):_vm._e()])}
var AuthorInfovue_type_template_id_7b46319c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AuthorInfo.vue?vue&type=template&id=7b46319c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AuthorInfo.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var AuthorInfovue_type_script_lang_js_ = ({
  name: 'AuthorInfo',
  props: {
    bot: Boolean,
    roleColor: String
  }
});
// CONCATENATED MODULE: ./src/components/AuthorInfo.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AuthorInfovue_type_script_lang_js_ = (AuthorInfovue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/AuthorInfo.vue?vue&type=style&index=0&lang=css&
var AuthorInfovue_type_style_index_0_lang_css_ = __webpack_require__("5e21");

// CONCATENATED MODULE: ./src/components/AuthorInfo.vue






/* normalize component */

var AuthorInfo_component = normalizeComponent(
  components_AuthorInfovue_type_script_lang_js_,
  AuthorInfovue_type_template_id_7b46319c_render,
  AuthorInfovue_type_template_id_7b46319c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AuthorInfo = (AuthorInfo_component.exports);
// CONCATENATED MODULE: ./src/util/filters.js
const dates = {
  formatDate(value) {
    if (!(value instanceof Date)) return value;
    return `${value.getMonth() + 1}/${value.getDate()}/${value.getFullYear()}`;
  },

  padZeroes(value) {
    const [month, day, year] = value.split('/');
    return `${month.padStart(2, 0)}/${day.padStart(2, 0)}/${year}`;
  }

};
/* harmony default export */ var filters = ({
  dates
});
// CONCATENATED MODULE: ./src/util/validators.js
const validators_dates = {
  validator(value) {
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;

    if (typeof value === 'string' && !dateRegex.test(value)) {
      return false;
    }

    return true;
  }

};
/* harmony default export */ var validators = ({
  dates: validators_dates
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DiscordMessage.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



const now = new Date();
/* harmony default export */ var DiscordMessagevue_type_script_lang_js_ = ({
  name: 'DiscordMessage',
  components: {
    AuthorInfo: AuthorInfo
  },
  filters: filters.dates,
  props: {
    author: {
      type: String,
      'default': 'User'
    },
    avatar: String,
    bot: Boolean,
    edited: Boolean,
    roleColor: String,
    timestamp: {
      type: [Date, String],
      'default': () => now,
      validator: validators.dates.validator
    },
    profile: String
  },

  data() {
    return {
      highlightMention: false
    };
  },

  computed: {
    compactMode() {
      return this.$parent.layout['discord-compact-mode'];
    },

    user() {
      const {
        $discordMessage
      } = this.$root;

      const resolveAvatar = avatar => $discordMessage.avatars[avatar] || avatar || $discordMessage.avatars.default;

      const profile = $discordMessage.profiles[this.profile] || {};
      const props = {
        author: this.author,
        bot: this.bot,
        roleColor: this.roleColor
      };
      return Object.assign(props, profile, {
        avatar: resolveAvatar(this.avatar || profile.avatar)
      });
    }

  },

  mounted() {
    this.highlightMention = this.$children.some(child => {
      return child.$options.name === 'Mention' && child.$props.highlight && child.$props.type !== 'channel';
    });
  }

});
// CONCATENATED MODULE: ./src/components/DiscordMessage.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_DiscordMessagevue_type_script_lang_js_ = (DiscordMessagevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/DiscordMessage.vue?vue&type=style&index=0&lang=css&
var DiscordMessagevue_type_style_index_0_lang_css_ = __webpack_require__("4c75");

// CONCATENATED MODULE: ./src/components/DiscordMessage.vue






/* normalize component */

var DiscordMessage_component = normalizeComponent(
  components_DiscordMessagevue_type_script_lang_js_,
  DiscordMessagevue_type_template_id_7d2ac308_render,
  DiscordMessagevue_type_template_id_7d2ac308_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DiscordMessage = (DiscordMessage_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"120fadbc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DiscordEmbed.vue?vue&type=template&id=deecb5fc&
var DiscordEmbedvue_type_template_id_deecb5fc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discord-embed"},[_c('div',{staticClass:"discord-left-border",style:({ 'background-color': _vm.color })}),_c('div',{staticClass:"discord-embed-container"},[_c('div',{staticClass:"discord-embed-content"},[_c('div',[(_vm.author.name)?_c('div',{staticClass:"discord-embed-author"},[(_vm.author.image)?_c('img',{staticClass:"discord-author-image",attrs:{"src":_vm.author.image,"alt":""}}):_vm._e(),(_vm.author.url)?_c('a',{attrs:{"href":_vm.author.url,"target":"_blank"}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.author.name)+"\n\t\t\t\t\t")]):_c('span',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.author.name)+"\n\t\t\t\t\t")])]):_vm._e(),(_vm.title)?_c('div',{staticClass:"discord-embed-title"},[(_vm.url)?_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.title)+"\n\t\t\t\t\t")]):_c('span',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.title)+"\n\t\t\t\t\t")])]):_vm._e(),_c('div',{staticClass:"discord-embed-description"},[_vm._t("default")],2),_vm._t("fields"),(_vm.image)?_c('img',{staticClass:"discord-embed-image",attrs:{"src":_vm.image,"alt":""}}):_vm._e()],2),(_vm.thumbnail)?_c('img',{staticClass:"discord-embed-thumbnail",attrs:{"src":_vm.thumbnail,"alt":""}}):_vm._e()]),(_vm.showFooter)?_c('div',{staticClass:"discord-embed-footer"},[(_vm.showFooterImage)?_c('img',{staticClass:"discord-footer-image",attrs:{"src":_vm.footerImage,"alt":""}}):_vm._e(),_c('span',[_vm._t("footer"),(_vm.showFooterSeparator)?_c('span',{staticClass:"discord-footer-separator"},[_vm._v("\n\t\t\t\t\t•\n\t\t\t\t")]):_vm._e(),(_vm.timestamp)?_c('span',[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm._f("padZeroes")(_vm._f("formatDate")(_vm.timestamp)))+"\n\t\t\t\t")]):_vm._e()],2)]):_vm._e()])])}
var DiscordEmbedvue_type_template_id_deecb5fc_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/DiscordEmbed.vue?vue&type=template&id=deecb5fc&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DiscordEmbed.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var DiscordEmbedvue_type_script_lang_js_ = ({
  name: 'DiscordEmbed',
  filters: filters.dates,
  props: {
    color: String,
    authorName: String,
    authorImage: String,
    authorUrl: String,
    title: String,
    url: String,
    thumbnail: String,
    image: String,
    footerImage: String,
    timestamp: {
      type: [Date, String],
      validator: validators.dates.validator
    }
  },
  computed: {
    author() {
      return {
        name: this.authorName,
        image: this.authorImage,
        url: this.authorUrl
      };
    },

    showFooter() {
      return this.$slots.footer || this.timestamp;
    },

    showFooterImage() {
      return this.$slots.footer && this.footerImage;
    },

    showFooterSeparator() {
      return this.$slots.footer && this.timestamp;
    }

  }
});
// CONCATENATED MODULE: ./src/components/DiscordEmbed.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_DiscordEmbedvue_type_script_lang_js_ = (DiscordEmbedvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/DiscordEmbed.vue?vue&type=style&index=0&lang=css&
var DiscordEmbedvue_type_style_index_0_lang_css_ = __webpack_require__("be01");

// CONCATENATED MODULE: ./src/components/DiscordEmbed.vue






/* normalize component */

var DiscordEmbed_component = normalizeComponent(
  components_DiscordEmbedvue_type_script_lang_js_,
  DiscordEmbedvue_type_template_id_deecb5fc_render,
  DiscordEmbedvue_type_template_id_deecb5fc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DiscordEmbed = (DiscordEmbed_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"120fadbc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/EmbedFields.vue?vue&type=template&id=0f4f6a4b&
var EmbedFieldsvue_type_template_id_0f4f6a4b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discord-embed-fields"},[_vm._t("default")],2)}
var EmbedFieldsvue_type_template_id_0f4f6a4b_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/EmbedFields.vue?vue&type=template&id=0f4f6a4b&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/EmbedFields.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var EmbedFieldsvue_type_script_lang_js_ = ({
  name: 'EmbedFields'
});
// CONCATENATED MODULE: ./src/components/EmbedFields.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_EmbedFieldsvue_type_script_lang_js_ = (EmbedFieldsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/EmbedFields.vue?vue&type=style&index=0&lang=css&
var EmbedFieldsvue_type_style_index_0_lang_css_ = __webpack_require__("7baf");

// CONCATENATED MODULE: ./src/components/EmbedFields.vue






/* normalize component */

var EmbedFields_component = normalizeComponent(
  components_EmbedFieldsvue_type_script_lang_js_,
  EmbedFieldsvue_type_template_id_0f4f6a4b_render,
  EmbedFieldsvue_type_template_id_0f4f6a4b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var EmbedFields = (EmbedFields_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"120fadbc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/EmbedField.vue?vue&type=template&id=727f046c&
var EmbedFieldvue_type_template_id_727f046c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discord-embed-field",class:{ 'discord-inline-field': _vm.inline }},[_c('div',{staticClass:"discord-field-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var EmbedFieldvue_type_template_id_727f046c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/EmbedField.vue?vue&type=template&id=727f046c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/EmbedField.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
/* harmony default export */ var EmbedFieldvue_type_script_lang_js_ = ({
  name: 'EmbedField',
  props: {
    title: {
      type: String,
      required: true
    },
    inline: Boolean
  }
});
// CONCATENATED MODULE: ./src/components/EmbedField.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_EmbedFieldvue_type_script_lang_js_ = (EmbedFieldvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/EmbedField.vue?vue&type=style&index=0&lang=css&
var EmbedFieldvue_type_style_index_0_lang_css_ = __webpack_require__("d8f7");

// CONCATENATED MODULE: ./src/components/EmbedField.vue






/* normalize component */

var EmbedField_component = normalizeComponent(
  components_EmbedFieldvue_type_script_lang_js_,
  EmbedFieldvue_type_template_id_727f046c_render,
  EmbedFieldvue_type_template_id_727f046c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var EmbedField = (EmbedField_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"120fadbc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Mention.vue?vue&type=template&id=6bd9495c&
var Mentionvue_type_template_id_6bd9495c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"discord-mention",style:(_vm.colorStyle)},[_vm._v("\n\t"+_vm._s(_vm.mentionCharacter)),_vm._t("default",[_vm._v(_vm._s(_vm.defaultContent))])],2)}
var Mentionvue_type_template_id_6bd9495c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Mention.vue?vue&type=template&id=6bd9495c&

// EXTERNAL MODULE: ./node_modules/hex-to-rgba/build/index.js
var build = __webpack_require__("ab14");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Mention.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var Mentionvue_type_script_lang_js_ = ({
  name: 'Mention',
  props: {
    highlight: Boolean,
    color: String,
    type: {
      type: String,
      'default': 'user',
      validator: value => ['user', 'channel', 'role'].includes(value)
    },
    profile: String
  },
  computed: {
    defaultContent() {
      const {
        type,
        profile
      } = this;
      const user = this.$root.$discordMessage.profiles[profile] || {};
      return type === 'user' && user.author ? user.author : type === 'channel' ? type : type.charAt(0).toUpperCase() + type.slice(1);
    },

    mentionCharacter() {
      return this.type === 'channel' ? '#' : '@';
    },

    roleColor() {
      const profile = this.$root.$discordMessage.profiles[this.profile] || {};
      return profile.roleColor || this.color;
    },

    colorStyle() {
      if (!this.roleColor || this.type !== 'role') return {};
      return {
        color: this.roleColor,
        'background-color': build_default()(this.roleColor, 0.1)
      };
    }

  },

  mounted() {
    if (this.roleColor && this.type === 'role') {
      this.$el.addEventListener('mouseover', this.setHoverColor);
      this.$el.addEventListener('mouseout', this.resetHoverColor);
    }
  },

  beforeDestroy() {
    if (this.roleColor && this.type === 'role') {
      this.$el.removeEventListener('mouseover', this.setHoverColor);
      this.$el.removeEventListener('mouseout', this.resetHoverColor);
    }
  },

  methods: {
    setHoverColor() {
      this.$el.style.backgroundColor = build_default()(this.roleColor, 0.3);
    },

    resetHoverColor() {
      this.$el.style.backgroundColor = build_default()(this.roleColor, 0.1);
    }

  }
});
// CONCATENATED MODULE: ./src/components/Mention.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Mentionvue_type_script_lang_js_ = (Mentionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/Mention.vue?vue&type=style&index=0&lang=css&
var Mentionvue_type_style_index_0_lang_css_ = __webpack_require__("2cc1");

// CONCATENATED MODULE: ./src/components/Mention.vue






/* normalize component */

var Mention_component = normalizeComponent(
  components_Mentionvue_type_script_lang_js_,
  Mentionvue_type_template_id_6bd9495c_render,
  Mentionvue_type_template_id_6bd9495c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Mention = (Mention_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"120fadbc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DiscordReactions.vue?vue&type=template&id=523b8561&
var DiscordReactionsvue_type_template_id_523b8561_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discord-reactions"},[_vm._t("default")],2)}
var DiscordReactionsvue_type_template_id_523b8561_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/DiscordReactions.vue?vue&type=template&id=523b8561&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DiscordReactions.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var DiscordReactionsvue_type_script_lang_js_ = ({
  name: 'DiscordReactions'
});
// CONCATENATED MODULE: ./src/components/DiscordReactions.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_DiscordReactionsvue_type_script_lang_js_ = (DiscordReactionsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/DiscordReactions.vue?vue&type=style&index=0&lang=css&
var DiscordReactionsvue_type_style_index_0_lang_css_ = __webpack_require__("4963");

// CONCATENATED MODULE: ./src/components/DiscordReactions.vue






/* normalize component */

var DiscordReactions_component = normalizeComponent(
  components_DiscordReactionsvue_type_script_lang_js_,
  DiscordReactionsvue_type_template_id_523b8561_render,
  DiscordReactionsvue_type_template_id_523b8561_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DiscordReactions = (DiscordReactions_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"120fadbc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DiscordReaction.vue?vue&type=template&id=01ab0e1e&
var DiscordReactionvue_type_template_id_01ab0e1e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discord-reaction",class:{ 'discord-reaction-active': _vm.active }},[_vm._v("\n\t"+_vm._s(_vm.count)+"\n")])}
var DiscordReactionvue_type_template_id_01ab0e1e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/DiscordReaction.vue?vue&type=template&id=01ab0e1e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DiscordReaction.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var DiscordReactionvue_type_script_lang_js_ = ({
  name: 'DiscordReaction',
  props: {
    active: Boolean,
    count: {
      type: Number,
      'default': 0
    }
  }
});
// CONCATENATED MODULE: ./src/components/DiscordReaction.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_DiscordReactionvue_type_script_lang_js_ = (DiscordReactionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/DiscordReaction.vue?vue&type=style&index=0&lang=css&
var DiscordReactionvue_type_style_index_0_lang_css_ = __webpack_require__("3f9e");

// CONCATENATED MODULE: ./src/components/DiscordReaction.vue






/* normalize component */

var DiscordReaction_component = normalizeComponent(
  components_DiscordReactionvue_type_script_lang_js_,
  DiscordReactionvue_type_template_id_01ab0e1e_render,
  DiscordReactionvue_type_template_id_01ab0e1e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DiscordReaction = (DiscordReaction_component.exports);
// CONCATENATED MODULE: ./src/index.js








/* harmony default export */ var src = ({
  install(Vue, options = {}) {
    const {
      avatars = {},
      componentNames = {},
      profiles = {}
    } = options;
    const discordAvatars = {
      blue: 'https://cdn.discordapp.com/attachments/654503812593090602/665721745466195978/blue.png',
      gray: 'https://cdn.discordapp.com/attachments/654503812593090602/665721746569166849/gray.png',
      green: 'https://cdn.discordapp.com/attachments/654503812593090602/665721748431306753/green.png',
      orange: 'https://cdn.discordapp.com/attachments/654503812593090602/665721750201434138/orange.png',
      red: 'https://cdn.discordapp.com/attachments/654503812593090602/665721752277483540/red.png'
    };
    Vue.prototype.$discordMessage = {
      avatars: Object.assign(discordAvatars, avatars, {
        'default': discordAvatars[avatars.default] || avatars.default || discordAvatars.blue
      }),
      profiles,
      defaultTheme: options.defaultTheme,
      defaultMode: options.defaultMode
    };
    if (!options.disableFont) __webpack_require__("1d0c");
    Vue.component(componentNames['discord-messages'] || 'discord-messages', DiscordMessages);
    Vue.component(componentNames['discord-message'] || 'discord-message', DiscordMessage);
    Vue.component(componentNames['discord-embed'] || 'discord-embed', DiscordEmbed);
    Vue.component(componentNames['embed-fields'] || 'embed-fields', EmbedFields);
    Vue.component(componentNames['embed-field'] || 'embed-field', EmbedField);
    Vue.component(componentNames.mention || 'mention', Mention);
    Vue.component(componentNames['discord-reactions'] || 'discord-reactions', DiscordReactions);
    Vue.component(componentNames['discord-reaction'] || 'discord-reaction', DiscordReaction);
  }

});
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src);



/***/ }),

/***/ "fdf5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2df6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("fb03c1be", content, true, {"sourceMap":false,"shadowMode":false});

/***/ })

/******/ })["default"];